import { ComponentPropsWithoutRef, FC, useCallback } from 'react';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react';

import { PhoneHelper } from 'modules/common/values';
import { CodeInput, Field, Form } from 'modules/common/ui';

import { PayHeader } from '../PayHeader';
import { FormRoot } from './Form.Root';
import { FormField } from './Form.Field';
import { Footer } from './Footer';
import { Timer } from './Timer';
import { Store } from '../../stores';
import { schema } from './CodeForm.Schema';

type Props = ComponentPropsWithoutRef<typeof Form>;

const FormComponent: FC<Props> = () => {
  const store = Store.use();
  const router = useRouter();

  const submitForm = useCallback(
    async (code: any) => {
      await store.submitConfirmForm(code, () => {
        router.push('/pay/send');
      });
    },
    [store, router],
  );

  /**
   * Обработка отправки формы
   */
  const handleChange = useCallback(
    async (value: string) => {
      if (value.length < 4) {
        return;
      }

      await submitForm(value);
    },
    [submitForm],
  );

  const phone = PhoneHelper.format(String(store?.phone?.value));
  return (
    <>
      <PayHeader
        title="Введите код из SMS"
        subtitle={`Мы отправили SMS с кодом подтверждения на номер  ${phone}`}
      />
      <FormRoot>
        <Form onSubmit={submitForm} schema={schema}>
          <FormField>
            <Field
              htmlFor="code"
              name="code"
              nativeErrors={false}
              error={store.errorMessage}
            >
              <CodeInput
                id="code"
                name="code"
                onChange={handleChange}
                autoFocus
              />
            </Field>
          </FormField>
          <Timer />
          <Footer />
        </Form>
      </FormRoot>
    </>
  );
};

export const CodeForm = observer(FormComponent);
